export const columnsToExport = [
  'armador',
  'contenedor',
  'tipo',
  'tamano',
  'peso',
  'precinto1',
  'precinto2',
  'precinto3',
  'precinto4',
  'imos',
  'uns',
  'temperatura',
  'ventilacion',
  'humedad',
  'viajeAnterior',
  'status',
  'destinoFinal',
  'viajeCarga',
];
